export default {
      id: "left-arrow-crm-usage",
      viewBox: "0 0 13 23",
      url: __webpack_public_path__ + "img/icons.deccda40.svg#left-arrow-crm",
      toString: function () {
        return this.url;
      }
    }